import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "./routes";

const AppBreadcrumb = () => {
  // console.log("%c [AppBreadcrumb Rendering] " + new Date().toLocaleTimeString(), "background: blue; color: white; font-size: 14px;");
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  const findRoute = (path) => {
    for (const route of routes) {
      if (!route.path) continue;
      const routeParts = route.path.split("/");
      const pathParts = path.split("/");
      if (routeParts.length !== pathParts.length) continue;

      const isMatch = routeParts.every(
        (part, idx) => part.startsWith(":") || part === pathParts[idx]
      );

      if (isMatch) return route;
    }
    return null;
  };

  const getBreadcrumbItems = (path) => {
    const current = findRoute(path);
    if (!current) return [];

    let crumbs = [];

    if (current.breadcrumb && current.breadcrumb.length > 0) {
      current.breadcrumb.forEach((parentPath) => {
        const parent = findRoute(parentPath);
        if (parent) {
          crumbs.push({ name: parent.name, path: parent.path });
        }
      });
    }

    crumbs.push({ name: current.name, path: current.path, active: true });
    return crumbs;
  };

  const breadcrumbs = getBreadcrumbItems(pathname);

  const handleManualNav = (e, path) => {
    e.preventDefault();
    e.stopPropagation();
    // console.log("[Breadcrumb Phase 2] Navigating to:", path);
    navigate(path);
  };

  const containerStyle = {
    padding: "0.5rem 0",
    marginBottom: "1rem",
    borderBottom: "1px solid #dee2e6"
  };

  const listStyle = {
    display: "flex",
    listStyle: "none",
    padding: 0,
    margin: 0,
    fontSize: "0.875rem"
  };

  const itemStyle = {
    display: "flex",
    alignItems: "center"
  };

  const linkStyle = {
    cursor: "pointer",
    color: "#0d6efd",
    textDecoration: "none"
  };

  const separatorStyle = {
    margin: "0 0.5rem",
    color: "#6c757d"
  };

  return (
    <nav aria-label="breadcrumb" style={containerStyle} data-debug="AppBreadcrumb-v7-Plain">
      <ol style={listStyle}>
        <li style={itemStyle}>
          <span
            role="button"
            tabIndex={0}
            onClick={(e) => handleManualNav(e, "/seller/dashboard")}
            onKeyDown={(e) => e.key === 'Enter' && handleManualNav(e, "/seller/dashboard")}
            style={linkStyle}
          >
            Sellers Home
          </span>
        </li>
        {breadcrumbs.map((b, i) => (
          <li key={i} style={itemStyle}>
            <span style={separatorStyle}> / </span>
            {b.active ? (
              <span style={{ color: "#6c757d" }}>{b.name}</span>
            ) : (
              <span
                role="button"
                tabIndex={0}
                onClick={(e) => handleManualNav(e, b.path)}
                onKeyDown={(e) => e.key === 'Enter' && handleManualNav(e, b.path)}
                style={linkStyle}
              >
                {b.name}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default React.memo(AppBreadcrumb);
